import React, { useState } from 'react';
import { Mail, Phone, MapPin, MessageCircle, Instagram, Facebook } from 'lucide-react';
import axios from 'axios';
import './Contact.css';
import { contactInfo } from '../mockData';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
      const API = `${BACKEND_URL}/api`;
      
      const response = await axios.post(`${API}/contact`, formData);
      alert(response.data.message);
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch (error) {
      alert('Failed to submit form. Please try again.');
      console.error(error);
    }
  };

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, '')}`, '_blank');
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-2">Get In Touch</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', marginTop: '1rem' }}>
            Have questions? We'd love to hear from you
          </p>
        </div>
        
        <div className="contact-grid">
          <div className="contact-info">
            <div className="contact-item">
              <div className="contact-icon">
                <Mail size={24} />
              </div>
              <div className="contact-details">
                <div className="contact-label">Email</div>
                <a href={`mailto:${contactInfo.email}`} className="contact-value">{contactInfo.email}</a>
              </div>
            </div>
            
            <div className="contact-item">
              <div className="contact-icon">
                <Phone size={24} />
              </div>
              <div className="contact-details">
                <div className="contact-label">Phone</div>
                <a href={`tel:${contactInfo.phone}`} className="contact-value">{contactInfo.phone}</a>
              </div>
            </div>
            
            <div className="contact-item">
              <div className="contact-icon">
                <MapPin size={24} />
              </div>
              <div className="contact-details">
                <div className="contact-label">Address</div>
                <div className="contact-value">{contactInfo.address}</div>
              </div>
            </div>
            
            <button className="btn-primary whatsapp-btn" onClick={handleWhatsApp}>
              <MessageCircle size={20} />
              Chat on WhatsApp
            </button>
            
            <div className="social-links">
              <a href={contactInfo.social.instagram} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                <Instagram size={24} />
              </a>
              <a href={contactInfo.social.facebook} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                <Facebook size={24} />
              </a>
            </div>
          </div>
          
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name" className="form-label">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="form-input"
                placeholder="Your name"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="form-input"
                placeholder="your@email.com"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="phone" className="form-label">Phone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                className="form-input"
                placeholder="+91 XXXXX XXXXX"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="message" className="form-label">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
                className="form-textarea"
                placeholder="Tell us how we can help you"
              />
            </div>
            
            <button type="submit" className="btn-primary submit-btn">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
